import React, { useEffect, useState } from "react";
import CustomTab from "../../components/ui/CustomTab";
import { useDispatch, useSelector } from "react-redux";
import { GetUserCountries, setState } from "./reviewSlice";
import { pushRoute, setSaveDashboardFormState } from "../../store/globalSlice";

const tabs = [
	{
		label: "Quota Modification",
		to: "order",
		value: "/review/order",
	},
];

export default function Review() {
	const dispatch = useDispatch();
	const state = useSelector((store) => store.review);
	const { countries, NavValue } = state;
	const [value, setValue] = useState(NavValue);

	useEffect(() => {
		//if (countries.length <= 0) {
		dispatch(GetUserCountries({ method: "Get" }));
		//}
		dispatch(setState("NavValue", 0));
		dispatch(setState("messageOpen", false));
		dispatch(setState("message", ""));
		dispatch(setState("severity", ""));
	}, []);

	useEffect(() => {
		setValue(NavValue);
	}, [NavValue]);

	useEffect(() => {
		dispatch(setSaveDashboardFormState(false));
		dispatch(pushRoute("review"));
	}, []);

	return <CustomTab tabs={tabs} />;
}
